import { createSelector } from 'reselect';

export const getSites = (state) => state.sites.sites;

export const getSiteSetAt = (state) => state.sites.siteSetAt;

export const getSite = createSelector(
  getSites,
  (_, siteId) => siteId,
  (sites, siteId) => sites.find((site) => site.id === siteId)
);

export const getCreatedSite = (state) => state.sites.createdSite;

export const getActiveSiteId = (state) => state.sites.activeSiteId;

export const getThumbnails = (state) => state.sites.thumbnails;

export const getModelThumbnail = createSelector(
  getThumbnails,
  (_state, modelId) => modelId,
  (_state, _modelId, versionId) => versionId,
  (thumbnails, modelId, versionId) => {
    if (!modelId || !versionId) return null;

    const thumbnailKey = `${modelId}/${versionId}`;
    if (thumbnails[thumbnailKey] === undefined) return null;

    return thumbnails[thumbnailKey];
  }
);

export const getActiveSite = createSelector([getActiveSiteId, getSites], (activeSiteId, sites) => {
  if (sites.length > 0 && activeSiteId) {
    return sites.find((site) => site.id === activeSiteId);
  }
  // return empty site obj if waiting on site data to diff from non-site
  return {};
});

export const getSitesLoaded = (state) => state.sites.sitesLoadedAt;
